import { Col, Container, Row } from 'react-bootstrap';

import { GameLogo } from '../../../../game-document/game-logo';
import { GameName } from '../../../../game-document/game-name';
import { GameHeader } from '../../../../game-document/game-header';
import { GameInfoContent } from '../../../../game-document/game-info-content';
import { EnterGameButton } from '../../../../../components/enter-game-button';

export const Info = () => {
  return (
    <>
      <Container className={'drawer__body'} fluid>
        <Row>
          <GameHeader />
        </Row>
        <Row>
          <Col className={'py-3 bg-success position-relative'}>
            <GameLogo
              className={
                'event-image position-absolute w-5 h-5 rounded-circle border border-5 border-dark bg-white'
              }
            />
            <p className={'mb-0 pl-12 ml-20  text-white'}>
              <strong>
                <GameName />
              </strong>
            </p>
          </Col>
        </Row>
        <Row className={'bg-white pt-5 pb-4'}>
          <GameInfoContent />
        </Row>
      </Container>

      <EnterGameButton />
    </>
  );
};
